if (!customElements.get('gaya-scroll-panels')) {
  customElements.define(
    'gaya-scroll-panels',
    class GayaScrollPanels extends HTMLElement {
      constructor() {
        super();
        this.requestUpdate = this.requestUpdate.bind(this);
        this.onResize = this.onResize.bind(this);
        this.ticking = false;
      }

      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-gaya-panel]'));
        this.counter = this.querySelector('[data-gaya-counter]');
        this.current = this.querySelector('[data-gaya-current]');
        this.overlayHeader = this.hasAttribute('data-overlay-header');
        this.header = document.querySelector('.section-header');

        if (this.overlayHeader && this.hasAttribute('data-recolor-logo')) {
          document.documentElement.setAttribute('data-gaya-recolor-logo', '');
        }

        window.addEventListener('scroll', this.requestUpdate, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.onResize();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.requestUpdate);
        window.removeEventListener('resize', this.onResize);
        document.documentElement.removeAttribute('data-gaya-tone');
        document.documentElement.removeAttribute('data-gaya-recolor-logo');
      }

      onResize() {
        // Pull the first panel up under the header so the photo fills the screen behind it
        if (this.overlayHeader && this.header) {
          this.style.marginTop = `-${this.header.offsetHeight}px`;
        }
        this.update();
      }

      requestUpdate() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      update() {
        if (!this.panels.length) return;

        const threshold = 60;
        const bounds = this.getBoundingClientRect();
        const active = bounds.bottom > threshold && bounds.top < window.innerHeight;

        // The last panel whose top has reached the header is the one on screen
        let index = 0;
        this.panels.forEach((panel, i) => {
          if (panel.getBoundingClientRect().top <= threshold) index = i;
        });
        const tone = this.panels[index].dataset.tone;

        if (this.overlayHeader) {
          if (active) {
            document.documentElement.setAttribute('data-gaya-tone', tone);
          } else {
            document.documentElement.removeAttribute('data-gaya-tone');
          }
        }

        if (this.counter) {
          this.counter.classList.toggle('is-visible', active);
          this.counter.dataset.tone = tone;
          if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
        }
      }
    }
  );
}
